import React, { useContext } from 'react'
import styles from './Footer.module.css'
import hotline from '../../public/assets/hotline.svg'
import email from '../../public/assets/mail.png'
import Logo from '../../public/assets/remitxLogo.png'
import { useMyContext } from '../../myContext'
import { Col, Row } from 'react-bootstrap'


const OnboardingFooter = () => {
	const { partnerEmail, contactNumber, siteDisclaimerLink} = useMyContext("");
    const contactMail = partnerEmail;
    const hotlineText = `Hotline : ${contactNumber}`
	return (
		<>
            <div className='container'>
        <Row className={`${styles.footer1} ${styles.footerMargin}`}  >
				<Col md={6} xs={12} className={styles.onBoardEmail} >
					<img src={email} className={styles.hotlineImage} alt="email" />
					<span>{contactMail}</span>
				</Col>
				<Col md={6} xs={12}  className={styles.onBoardPhone}>
					<img src={hotline} className={styles.hotlineImage} alt="phone" />
                    <span>{hotlineText ? hotlineText :'Hotline : --'}</span>
                    <span> (10 AM - 7 PM IST)</span>
				</Col>
			</Row>
       <Row className={styles.footer1} style={{justifyContent:"center"}}>
            <Col md={12} xs={12} sm={12}  className={`${styles.onBoardMobileBorderless} ${styles.boardNotDisclaimer}`}>
                <div>©Borderless Softtech Pvt Ltd, a subsidiary of Borderless Investing Inc. {new Date().getFullYear()}</div>
            </Col>
            <Col className={styles.inBoardDisclaimer} md={12} xs={12} sm={12} >
            <a 
            href={siteDisclaimerLink}
            target="_blank" rel="noopener noreferrer"> Disclaimer</a>
            </Col>
       </Row>
       </div>
		</>
	)
}

export default OnboardingFooter
